import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { AlertExportButton } from 'components';
import { clearAlertExportCsvData, fetchAlertExportCsvData } from 'actions';
import { selectAlertExportCsvData, selectFetchingCsvData } from 'selectors';
import { AlertActionFilter } from 'model';

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchAlertExportCsvData: (userId: string, filter: Partial<AlertActionFilter>) => dispatch(fetchAlertExportCsvData(userId, filter)),
  clearAlertExportCsvData: () => dispatch(clearAlertExportCsvData()),
});

type SelectedValues = {
  alertExportCsvData: string | null;
  fetchingCsvData: boolean;
};

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  alertExportCsvData: selectAlertExportCsvData(),
  fetchingCsvData: selectFetchingCsvData(),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertExportButton);
